import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ModuleService } from '../../../Model/Module/module.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
interface Module {
  DefaultTAT_InDays: number
  ModuleName: string
  WebESSModuleMasterID: number

}
@Component({
  selector: 'app-tat',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule],
  templateUrl: './tat.component.html',
  styleUrl: './tat.component.scss'
})
export class TATComponent {
  isDisabled: boolean = false;
  dtoptions: DataTables.Settings = {};
  ModuleData: Module[] = [];
  TatData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective

  constructor(
    private module: ModuleService,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
  }

  filter = {
    SelectType: 'S',
    WebESSModuleMasterID: 0
  }
  ngOnInit(): void {
    this.dtoptions = {
      searching: true,
      paging: false,
      info: false,
      language: {
        searchPlaceholder: 'Search...',
      },
      columns: [
        { name: "Module Name", orderable: true },
        { name: "TAT(Days)", orderable: false },
      ]
    };
    this.GetModule();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.ModuleData.findIndex(e => this.common.parseFloat(e.DefaultTAT_InDays) > 99) == -1) {
        this.SaveModule();
      } else {
        form.submitted = true;
        this.toast.show({ message: "Maximum allow TAT das's 99", type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  GetModule() {
    this.isDisabled = true;
    this.module.GetModule(this.filter).subscribe({
      next: (response) => {
        console.log(response);
        this.ModuleData = Object.values(response.Table)
        //this.DataTable.LoadData(response.Table);
        this.isDisabled = false;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          // Destroy the table first
          dtInstance.destroy();
          // Call the dtTrigger to rerender again
          this.dtTrigger.next(null);
        });
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveModule() {
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit) {
      this.isDisabled = true;
      this.ModuleData.forEach(element => {
        this.module.SaveModule({ SelectType: 'U', WebESSModuleMasterID: element['WebESSModuleMasterID'], DefaultTAT_InDays: element['DefaultTAT_InDays'] }).subscribe({
          next: (response) => {
            console.log(response.Error_Message);

          },
          complete: () => { },
          error: (error) => { },
        });
      });
      this.toast.show({ message: "Save successfully.", type: toastTypeEnum.success });
      this.isDisabled = false;
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'TATMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.TatData = data;
        if (this.TatData.length > 0) {
          this.download.exportToExcel(this.TatData, "TAT_data");
          this.isDisabled = false;
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false;
        }
      });
  }
}
